exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-9d60d104]{width:90%;margin:50px auto 0}.stepFour-content[data-v-9d60d104]{width:100%;margin:50px auto 0;text-align:center}.stepFour-content i[data-v-9d60d104]{font-size:40px;color:#19be6b}.stepFour-content p[data-v-9d60d104]{margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-9d60d104&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/mobile/stepFour.vue
// module id = 161
// module chunks = 0